<template>
  <div class="prompt-concepts" v-if="concepts.length > 0">
    <div class="prompt-concepts__title">Suggested concepts:</div>
    <div class="prompt-concepts__list">
      <div class="prompt-concepts__item" v-for="concept in concepts" :key="concept.title">
        <div
          role="button"
          tabindex="0"
          @click="onSelectConcept(concept)"
          @keydown.enter.prevent="onSelectConcept(concept)"
          @keydown.space.prevent="onSelectConcept(concept)"
        >
          {{ concept.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromptConcepts',
  props: {
    concepts: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onSelectConcept(concept) {
      if (!concept) return;
      this.$emit('select-concept', concept);
    },
  },
};
</script>

<style lang="scss" scoped>
.prompt-concepts {
  padding-block: 8px;
}
.prompt-concepts__title {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 8px;
  font-style: italic;
  opacity: 0.6;
}

.prompt-concepts__list {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  flex: 1 1 auto;
}

.prompt-concepts__item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid var(--v-border-base);
  background: #ffffff;
  backdrop-filter: blur(6px);
  cursor: pointer;
  white-space: nowrap;
  font-size: 13px !important;
  font-weight: 500;
  gap: 0 !important;
  transition: all 0.3s ease;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);

  &:hover {
    background: var(--main-background);
  }

  &-icon {
    margin-right: 6px;
  }
}
</style>
